// OutlookEmbed.jsx

const OutlookEmbed = () => {
	// Pull your URL from an env var so it's not hard-coded
	const calendarUrl = process.env.REACT_APP_OUTLOOK_CALENDAR_URL;

	return (
		<div className="outlook-calendar">
			<iframe
				title="Company Outlook Calendar"
				src={calendarUrl}
				className="outlook-calendar__iframe"
				width={'100%'}
				maxWidth={'1920px'}
				height={'1000px'}
				frameBorder="0"
				scrolling="yes"
				loading="lazy"
				sandbox="allow-scripts allow-same-origin"
			>
				{/* Fallback content for browsers that don’t support iframes */}
				Your browser doesn’t support calendars.
				<a href={calendarUrl} target="_blank" rel="noopener noreferrer">
					Try to open calendar in a new tab
				</a>
			</iframe>
		</div>
	);
};

export default OutlookEmbed;
